import { FormProvider } from "react-hook-form";

import { Button, Stack } from "@seneca/senekit";

import ControlledTextInput from "seneca-common/utils/form-hook/inputs/ControlledTextInput";

import { userAccountType } from "features/user";

import { MarketingEmailsCheckbox } from "./form";
import useSignUpUserDetailsForm from "./hooks/useSignUpUserDetailsForm";
import { SignUpCardContent } from "./Layout";

type Props = {
  showMarketingEmailsCheckbox: boolean;
  afterSubmit: (arg: { isSubscribedToMarketingEmails?: boolean }) => void;
  familyName: string | undefined;
  givenName: string | undefined;
};

export default function SignUpParentUserDetailsForm({
  showMarketingEmailsCheckbox,
  afterSubmit,
  familyName,
  givenName
}: Props) {
  const { form, onFormSubmit } = useSignUpUserDetailsForm({
    defaultValues: {
      familyName,
      givenName
    },
    accountType: userAccountType.schoolparent
  });

  const onSubmit = () => {
    onFormSubmit();
    const isSubscribedToMarketingEmails = showMarketingEmailsCheckbox
      ? !!form.getValues("isSubscribedToMarketingEmails")
      : undefined;
    afterSubmit({ isSubscribedToMarketingEmails });
  };

  const focusedElement = getFocusedElement({ givenName, familyName });

  return (
    <FormProvider {...form}>
      <SignUpCardContent>
        {{
          body: (
            <Stack space="xlarge">
              <ControlledTextInput
                name="givenName"
                label="First name"
                autoFocus={focusedElement === "givenName"}
              />
              <ControlledTextInput
                name="familyName"
                label="Last name"
                autoFocus={focusedElement === "familyName"}
              />
              {showMarketingEmailsCheckbox && <MarketingEmailsCheckbox />}
            </Stack>
          ),
          footer: (
            <Button
              type="submit"
              width="100%"
              onClick={form.handleSubmit(onSubmit)}
              loading={form.formState.isSubmitting}
            >
              Continue
            </Button>
          )
        }}
      </SignUpCardContent>
    </FormProvider>
  );
}

function getFocusedElement({
  givenName,
  familyName
}: {
  givenName: string | undefined;
  familyName: string | undefined;
}) {
  if (givenName && !familyName) {
    return "familyName";
  }

  if (familyName && givenName) {
    return "familyName";
  }

  return "givenName";
}
